export const DEFAULT_ZOOM = 4;
export const DEFAULT_CENTER = { lat: 48.8566, lng: 2.3522 };
export const PROVIDER_URL = `https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png?key=${
  import.meta.env.VITE_CARTO_API_KEY || ''
}`;
export const ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors | &copy; <a href="https://carto.com/attributions">CARTO</a>';
export const NOMINATIM_BASE = 'https://nominatim.openstreetmap.org';
